import config from 'app/config';
import { clientFetch } from 'utils/client-fetch';
import { TokensResponse } from './types';


export const listTokens = async (personId: string): Promise<TokensResponse> =>
    clientFetch({
        method: 'get',
        url: `${config.TOKEN_API_URL}/search?personId=${personId}`,
    });
